import React, { memo } from 'react'
import { Card, Stack } from '@mui/material'

import { openExternalUrl } from 'src/libs/qb-brand-web-components'
import Button from '../../../../components/shared/button/Button'
import CardHeading from '../../../../components/text/CardHeading'

const GetFounderKey = ({ t }) => {
  return (
    <Card sx={{ width: 1, textAlign: 'center', p: 3 }}>
      <CardHeading title={t('brand:wallet.get-founders-key')} />
      <Stack spacing={3} alignItems='center'>
        <Button
          label={'Opensea'}
          onClick={() =>
            openExternalUrl('https://opensea.io/collection/qbx-genesis-nft')
          }
        />
        <Button
          label={'Blur'}
          onClick={() =>
            openExternalUrl('https://blur.io/eth/collection/qbx-genesis-nft')
          }
        />
      </Stack>
    </Card>
  )
}

export default memo(GetFounderKey)
